import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import useCategories from "../../../../utils/useCategories";
import ICONS from "../../../../assets/Icons";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { scheduleSuccessDetail } from "../../../../redux/features/scheduleTransaction";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import globalText from "../../../../utils/globalText";
import { globalTextFormat } from "../../../../utils/globalTextFormat";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";

const ScheduleBeneficiaryTransactionSuccess = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const prevIdRef = useRef(null);
  const categoryMapper = useCategories();

  const services = useSelector((state) => state.refreshToken.services);
  const { scheduleSuccessData } = useSelector((state) => state.schedulesTxn);

  const frequency = scheduleSuccessData?.transaction?.[0]?.frequency;

  const capitalizedFrequency = frequency
    ? frequency.charAt(0).toUpperCase() + frequency.slice(1).toLowerCase()
    : "";

  const beneAccount = () => {
    const beneId =
      scheduleSuccessData?.transaction?.[0]?.beneficiary_account_id;

    navigate(
      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${beneId}`,
    );
  };

  const sourceAccount = () => {
    const sourceId = scheduleSuccessData?.transaction?.[0]?.owner_account_id;
    navigate(
      `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${sourceId}`,
    );
  };

  const formateDate = (date) => {
    const dates = new Date(date || new Date());
    const day = dates.toLocaleDateString("en-GB", {
      day: "2-digit",
    });
    const month = dates.toLocaleDateString("en-GB", {
      month: "short",
    });
    const year = dates.toLocaleDateString("en-GB", {
      year: "numeric",
    });
    return `${day} ${month}, ${year}`;
  };

  const createScheduleTxn = () => {
    navigate("/beneficiary_transaction_dashboard/create_schedule");
  };
  const viewScheduleTxn = () => {
    navigate(
      `/beneficiary_transaction_dashboard/schedule_view_all/schedule_detail_page/${id}`,
    );
  };
  const goToDashboard = () => {
    navigate("/beneficiary_transaction_dashboard");
  };

  const buttonRows = [
    [
      {
        btnText: "Create schedule",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.ADD_BUTTON,
        handleFunction: createScheduleTxn,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: viewScheduleTxn,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: goToDashboard,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (!id || !services) return;

    if (prevIdRef.current === id) return;

    prevIdRef.current = id;

    dispatch(scheduleSuccessDetail(id));
  }, [id, services, dispatch]);
  return (
    <div>
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title={
          scheduleSuccessData?.transaction?.[0]?.lifecycle_status === "approved"
            ? globalText?.SCHEDULE_BENE_CREATED_AND_APPROVED
            : globalText?.SCHEDULE_CREATED_SUCCESS
        }
        subtitle=""
      >
        <TabsWeapperSection
          title={globalTextFormat(globalText?.TRANSFER_DETAILS, [0])}
        >
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    scheduleSuccessData?.transaction?.[0]?.scheduled_name,
                  leftSubTitle: globalTextFormat(globalText?.SCHEDULE_NAME, [
                    0,
                  ]),
                  hasRight: true,
                  rightText: true,
                  rightTitle: (
                    <>
                      INR{" "}
                      <FormatAmount
                        price={scheduleSuccessData?.transaction?.[0]?.amount}
                      />
                    </>
                  ),
                  rightTextFontWeight: "semibold",
                  rightTitleTextColor: "var(--text-primary)",
                  rightSubTitle: "Amount",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              onClick={sourceAccount}
              hoverable="black"
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    scheduleSuccessData?.transaction?.[0]
                      ?.owner_account_bank_acc_no,
                  ),
                  leftSubTitle: globalTextFormat(
                    globalText?.SOURCE_ACCOUNT_DETAILS,
                    [0],
                  ),
                  ifsc: scheduleSuccessData?.transaction?.[0]
                    ?.owner_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              onClick={beneAccount}
              hoverable="black"
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    scheduleSuccessData?.transaction?.[0]
                      ?.beneficiary_account_bank_acc_no,
                  ),
                  leftSubTitle: globalTextFormat(
                    globalText?.DESTINATION_ACCOUNT_DETAILS,
                    [0],
                  ),
                  ifsc: scheduleSuccessData?.transaction?.[0]
                    ?.beneficiary_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    scheduleSuccessData?.transaction?.[0]?.category ||
                    "Not available",
                  leftSubTitle: globalTextFormat(
                    globalText?.TRANSACTION_CATEGORY,
                    [0],
                  ),
                  icon: categoryMapper(
                    scheduleSuccessData?.transaction?.[0]?.category,
                  ),
                },
              ]}
            />

            {scheduleSuccessData?.transaction?.[0]?.confidential_transaction ===
              "Y" && (
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle:
                      scheduleSuccessData?.transaction?.[0]
                        ?.confidential_transaction === "Y"
                        ? "Yes"
                        : "No",
                    leftSubTitle: globalTextFormat(
                      globalText?.CONFIDENTIAL_TRANSACTION,
                      [0],
                    ),
                    icon: ICONS?.CONFIDENTIAL_TRANSACTION_BLUE_BG,
                  },
                ]}
              />
            )}

            {/* <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    scheduleSuccessData?.transaction?.[0]?.lifecycle_status ===
                    "pending"
                      ? "Pending"
                      : scheduleSuccessData?.transaction?.[0]
                            ?.lifecycle_status === "approved"
                        ? "Created distribution"
                        : scheduleSuccessData?.transaction?.[0]
                            ?.lifecycle_status,
                  leftSubTitle: globalTextFormat(globalText?.TRANSACTION_STATUS, [0]),

                  iconColor:
                    scheduleSuccessData?.transaction?.[0]?.lifecycle_status ===
                    "pending"
                      ? ICONS?.PENDING_BLUE
                      : scheduleSuccessData?.transaction?.[0]
                            ?.lifecycle_status === "approved"
                        ? ICONS?.QUEUED
                        : ICONS?.LOADER,
                },
              ]}
            /> */}
          </>
        </TabsWeapperSection>
        <TabsWeapperSection
          title={globalTextFormat(globalText?.SCHEDULE_DETAILS, [0])}
        >
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: capitalizedFrequency,
                  leftSubTitle: globalText?.FREQUENCY,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: formateDate(
                    scheduleSuccessData?.transaction?.[0]
                      ?.transaction_start_date,
                  ),
                  leftSubTitle: globalTextFormat(
                    scheduleSuccessData?.transaction?.[0]?.frequency === "once"
                      ? globalText?.ON_DATE
                      : globalText?.FIRST_OCCURRENCES_DATE,
                    [0],
                  ),
                },
              ]}
            />

            {scheduleSuccessData?.transaction?.[0]?.frequency !== "once" && (
              <>
                <InfoCard
                  bgColor="var(--positive-card)"
                  rows={[
                    {
                      leftTitle: formateDate(
                        scheduleSuccessData?.transaction?.[0]
                          ?.transaction_start_date,
                      ),
                      leftSubTitle: globalTextFormat(globalText?.START_DATE, [
                        0,
                      ]),
                    },
                  ]}
                />

                <InfoCard
                  bgColor="var(--positive-card)"
                  rows={[
                    {
                      leftTitle: formateDate(
                        scheduleSuccessData?.transaction?.[0]
                          ?.transaction_end_date,
                      ),
                      leftSubTitle: globalText?.END_DATE,
                    },
                  ]}
                />
              </>
            )}

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: scheduleSuccessData?.transaction?.[0]?.slot
                    ? (() => {
                        const [startRaw, endRaw] =
                          scheduleSuccessData?.transaction?.[0]?.slot.split(
                            " - ",
                          );

                        const formatTo12Hour = (timeStr) => {
                          const cleaned = timeStr
                            .trim()
                            .replace(/\s?(am|pm)$/i, "");
                          const [hours, minutes] = cleaned
                            .split(":")
                            .map(Number);

                          const date = new Date();
                          date.setHours(hours);
                          date.setMinutes(minutes);
                          const formatted = date.toLocaleTimeString("en-US", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          });

                          const [time, ampm] = formatted.split(" ");
                          return (
                            <>
                              {time}&nbsp;
                              <span className="text-font-md lowercase">
                                {ampm}
                              </span>
                            </>
                          );
                        };

                        return (
                          <>
                            {formatTo12Hour(startRaw)} to{" "}
                            {formatTo12Hour(endRaw)}
                          </>
                        );
                      })()
                    : globalText?.NOT_AVAILABLE,
                  leftSubTitle: globalTextFormat(globalText?.TIME_SLOT, [0]),
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: scheduleSuccessData?.transaction?.[0]?.occurrences,
                  leftSubTitle: globalTextFormat(globalText?.OCCURRENCES, [0]),
                },
              ]}
            />
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </div>
  );
};

export default ScheduleBeneficiaryTransactionSuccess;
